import { useEffect, useState } from 'react';
import { ValidationStatus, formatSnakeCase } from '@jove-frontend/uikit';
import clsx from 'clsx';
import { capitalize } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";

var ValidationStatusView = function ValidationStatusView(props) {
  var className = props.className,
      status = props.status;

  var _useState = useState({}),
      containerStyle = _useState[0],
      setContainerStyle = _useState[1];

  var _useState2 = useState(''),
      showText = _useState2[0],
      setShowText = _useState2[1];
  /**
   * effects
   */


  useEffect(function () {
    evaluateTextInfo();
  }, [status]);
  /**
   * methods
   */

  var evaluateTextInfo = function evaluateTextInfo() {
    var showText = capitalize(formatSnakeCase(status));
    var textColor = '#0E35D1';

    switch (status) {
      case ValidationStatus.NOT_STARTED:
        textColor = '#707070';
        break;

      case ValidationStatus.PAYE_CONTRACTOR:
        textColor = '#474747';
        break;

      case ValidationStatus.SUCCESS:
        textColor = '#1CB258';
        break;

      case ValidationStatus.CANCELLED:
      case ValidationStatus.EXPIRED:
        textColor = '#DD1F1F';
        break;

      case ValidationStatus.EXPIRE_SOON:
      case ValidationStatus.URGENT_EXPIRING:
        textColor = '#E76F2B';
        break;

      case ValidationStatus.FAIL:
        textColor = '#DD1F1F';
        break;

      default:
        break;
    } // Special handle


    if (status === ValidationStatus.IN_PROGRESS) {
      showText = 'Pending';
    }

    setShowText(showText);
    setContainerStyle({
      borderColor: "".concat(textColor),
      color: "".concat(textColor)
    });
  };

  if (!status) {
    return null;
  }

  return /*#__PURE__*/_jsx("div", {
    style: containerStyle,
    className: clsx('inline-flex flex-row rounded-lg border px-[8px] py-[6px] text-sm font-bold leading-4', className),
    children: showText
  });
};

export default ValidationStatusView;